import styled from '@emotion/styled';
import { fontSize } from '@styles/globalStyles';

export const CompanyName = styled.h2`
  text-transform: uppercase;
  font-size: ${fontSize(18)};
  padding: 32px 0 24px;

  a {
    color: #00202d;
    text-decoration: none;
    display: block;
  }
`;

export const Logo = styled.div`
  margin-bottom: 36px;
`;

export const Contact = styled.div`
  strong {
    font-weight: 700;
    display: block;
    margin-bottom: 8px;
  }

  ul {
    li {
      display: block;
      padding: 8px 0;
      a {
        color: ${({ theme }) => theme.colors.link.primary};
      }
    }
  }
`;

export const EditLinkWrapper = styled.div`
  position: absolute;
  right: 0;
  top: -45px;
`;
